
import TestInstructionsStepTwoComponent from "@/components/Shared/RegisterTest/TestInstructionsStepTwo/TestInstructionsStepTwoComponent";
export default TestInstructionsStepTwoComponent;
